<template>
    <rkm-modal
        :buttons="['cancel']"
        extraLarge
        ref="ModalView"
        title="Visualização de arquivo"
    >
        <template>
            <div v-if="currentFileType === 'pdf'">
                <iframe
                    :height="iframeHeight"
                    :src="fileUrl"
                    style="border: none;"
                    width="100%"
                >
                </iframe>
            </div>

            <div v-if="currentFileType === 'image'" class="image-container">
                <img
                    :src="fileUrl"
                    :title="getNameArchive"
                    alt="Visualização da imagem"
                    class="centered-image"
                />
            </div>
        </template>
    </rkm-modal>
</template>

<script>

// Vuex.
import { mapGetters, mapActions } from 'vuex'

//Mixins.
import { repository } from '@/mixins'

export default {
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
        getNameArchive() {
            if (this.nameArchive === null) return '';

            return this.nameArchive;
        },
    },
    created() {
        this.repositories = {
            upload: this.getConectaSusRepository('regulacao.upload'),
        }
    },
    data: () => ({
        currentFileType: '',
        fileUrl: '',
        iframeHeight: '500px',
        nameArchive: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        updateIframeHeight() {
            const availableHeight = window.innerHeight * 0.75;
            this.iframeHeight = availableHeight + 'px';
        },
        open(item) {
            this.nameArchive = item.arquivo.split('/').pop();
            const fileExtension = item.arquivo.split('.').pop().toLowerCase();

            this.currentFileType = fileExtension === 'pdf' ? 'pdf' : 'image';

            this.repositories.upload.view(item.id)
                .then(response => {

                    const blob = new Blob([response.data], { type: response.headers['content-type'] });
                    this.fileUrl = window.URL.createObjectURL(blob);
                    this.$refs.ModalView.show();

                })
                .catch(error => {
                    console.error('Erro ao visualizar o arquivo:', error);
                });
        },
    },
    mounted() {
        this.updateIframeHeight();
        window.addEventListener('resize', this.updateIframeHeight);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.updateIframeHeight);
    },
    mixins: [repository],
}
</script>

<style scoped>
    .image-container {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
    }
    .centered-image {
        max-width: 100%;
        max-height: 90%;
        display: block;
        margin: auto;
    }
</style>